import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';

import { UiHelper } from '@helpers/ui.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { filter } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';

import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { UserHelper } from '@helpers/user.helper';

@Component({
  selector: 'prematch-component',
  templateUrl: '../sharedTemplates/prematch.component.html',
})
export class PreMatchComponent {
  @Input()
  oddMarketingValue = 0;

  @Input()
  _isFavories = false;

  @Input()
  preMatchobservable = new BehaviorSubject<any>([]);

  @Input()
  _selectedOdds: OddModel[] = [];

  @Input()
  oddTiles = [];

  @Output() favChanged = new EventEmitter();

  panLeft = '0';

  styles = {
    vScrool: { height: this._UiHelper.windowsHeight - 200 + 'px' },
  };

  constructor(
    private _ApiService: ApiService,
    private _UiHelper: UiHelper,
    private _LocalizationService: LocalizationService,
    public _UserHelper: UserHelper,
    public _Router: Router
  ) {
    this._UiHelper.windowResized.subscribe(c => {
      this.styles.vScrool.height = this._UiHelper.windowsHeight - 160 + 'px';
    });
    this.styles.vScrool.height = this._UiHelper.windowsHeight - 160 + 'px';
    //this._UiHelper.documentScrollListener.subscribe((x) => {
    //  //////console.warn("documentScrollListener", x, this._UiHelper.windowsHeight);
    //  if (x >= 75) {
    //    if (this.styles.vScrool.height != (this._UiHelper.windowsHeight - 76) + "px")
    //      this.styles.vScrool.height = (this._UiHelper.windowsHeight - 76) + "px";
    //  }
    //  else if (x == 0) {
    //    this.styles.vScrool.height = (this._UiHelper.windowsHeight - 190) + "px";
    //  }
    //});
  }

  addOddListener(e) {
    this.clickOddUP(e);
  }

  checkOddId(oddId) {
    const index = this._ApiService.slipCurrents.findIndex(v => {
      return v.OddId == oddId;
    });
    if (index > -1) {
      return 'active';
    } else {
      return '';
    }
  }

  clickOddUP(oddId) {
    this._ApiService.addOdd(oddId);
  }

  clickOddUpNew(odd, event) {
    //this._ApiService.addOddNew(odd,"0",event);
  }

  favorableStateChanged(e, _id) {
    this._UserHelper.toogleFavoried(_id);
    this.favChanged.emit();
  }

  goEventDetail(e) {
    //this._Router.navigate(['/eventdetail'], { queryParams: { eventID: e } });
    this._Router.navigate(['/eventdetail', e]);
    ////console.log('e', e);
  }

  swipe1(e): void {
    ////console.log(e);
    this.panLeft = '0';
  }

  swipe(e): void {
    ////console.log(e);

    this.panLeft = e.distance;
    /*
    const coord: [number, number] = [e.changedTouches[0].pageX, e.changedTouches[0].pageY];
        const time = new Date().getTime();
        if (when === 'start') {
          this.swipeCoord = coord;
          this.swipeTime = time;
          ////console.log(this.swipeCoord);
        } else if (when === 'end') {
          const direction = [coord[0] - this.swipeCoord[0], coord[1] - this.swipeCoord[1]];
          const duration = time - this.swipeTime;

          if (duration < 1000 //
            && Math.abs(direction[0]) > 30 // Long enough
            && Math.abs(direction[0]) > Math.abs(direction[1] * 3)) { // Horizontal enough
            const swipe = direction[0] < 0 ? 'next' : 'previous';
            // Do whatever you want with swipe
          }
        }

        */
  }

  public compareItems(match1: any, match2: any): boolean {
    if (match1 == undefined || match2 == undefined) return true;
    return match1.BetradarMatchId === match2.BetradarMatchId;
  }

  pairWithEventName(index: number, event: any) {
    return event.TournamentId;
  }
}

export class OddModel {
  constructor(OddId: number) {
    this.OddId = OddId;
  }

  OddId: number;
}
